export default __webpack_public_path__ + "static/img01-0abcb36f29f4fbcd666c3492d32466a0.png";